import {
    Modal,
    Container,
} from "react-bootstrap";
import React from "react";
import ReactLoading from "react-loading";

//css
import "./Modal.css";

function EditModal(props) {
    // const [editData, setEditData] = useState({});
    // const handleEditChange = (e) => {
    //   const {name,value} = e.target;
    //   // setEditData((prev)=>{...prev, name: [value]})
    // }
    return (
        <div>
            <Modal
                show={props.show}
                onHide={props.onHide}
                size={props.size}
                centered
                backdrop="static" 
            >
                <Modal.Header closeButton />
                <Modal.Body>
                    <div className="col-sm-12">
                        <p className="custom-modal-body-title">
                            {" "}
                            EDIT {props.title}{" "}
                        </p>
                        <Container
                            fluid
                            className="modal-cont justify-content-center"
                        >
                            {/* {props.type === "supplier" && (EditSupplier())}
              {props.type === "bank" && (EditBank())}
              {props.type === "branch" && (EditBranch())}
              {props.type === "ingredient" && (EditIngredient())}
              {props.type === "product" && (EditProduct())}
              {props.type === "user" && (EditUser())}
              {props.type === "employee" && (EditEmployee())} */}
                            {props.children}
                        </Container>

                        <div className="col-sm-12 mt-3 d-flex justify-content-end">
                            <button
                                className="button-secondary me-3"
                                onClick={props.onHide}
                            >
                                Cancel
                            </button>
                            {props.isClicked === true && (
                                <div className="button-primary d-flex justify-content-center">
                                    <ReactLoading
                                        type="bubbles"
                                        color="#FFFFFF"
                                        height={50}
                                        width={50}
                                    />
                                </div>
                            )}
                            
                            {props.isClicked === false && (
                                <button
                                    className="button-primary"
                                    onClick={props.onSave}
                                >
                                    Save
                                </button>
                            )}
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
}

EditModal.defaultProps = {
    title: "",
    // type:"",
    size: "xl",
    show: () => {},
    onHide: () => {},
    onSave: () => {},
};

export default EditModal;
